// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EiGh","top":"styles_top__17jvZ"};